import React from "react";
import PropTypes from "prop-types";

function CollectionQuoteItem({ text, author }) {
    return (
        <blockquote className="CollectionCortisQuote">
            <p className="CollectionCortisQuote-text">{text}</p>
            <footer className="CollectionCortisQuote-author">- {author} -</footer>
        </blockquote>
    );
}

CollectionQuoteItem.propTypes = {
    text: PropTypes.string.isRequired,
    author: PropTypes.string,
};

export default React.memo(CollectionQuoteItem);
